import type { ICampaign } from "../../../../types/models/campaign.models.types";

import { usePutHttp } from "../../http.hook";

interface IBody {
  budgetInternal: number;
}

interface IResponse {
  campaign: ICampaign;
}

export function useUpdateCampaignBudgetInternalByIdAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/campaigns/:id/update-budget-internal",
  });
}
